  <template>
    <lazy-div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-card>
               <v-card-title>
                <v-flex lg4 md4 xs12>
                  <v-autocomplete :label="labels.viewType" :items="custLogTypeViewList" v-model="viewType" item-text="label" item-value="value" data-vv-name="viewType" :data-vv-as="labels.viewType" :error-messages="errors.collect('viewType')" @change="doFilters"></v-autocomplete>
                </v-flex>
                <!-- <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field> -->
                <v-spacer></v-spacer>
                <!-- <v-btn color="primary" dark class="mb-2" @click="doPrint">
                  Print
                  <v-icon right>mdi-printer</v-icon>
                </v-btn> -->
                <!-- <v-btn color="primary" dark class="mb-2" @click="doCreateNew" :disabled="disabledAdd">
                  New Customer Log
                  <v-icon right>mdi-plus</v-icon>
                </v-btn> -->
              </v-card-title>
              <v-data-table :headers="headers" :items="items" :loading="loading" :options.sync="pagination" :server-items-length="totalItems" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
                <template v-slot:item="row">
                  <tr :class="{ activeCustLog : selectedCustLogRecord == parseInt(row.item.seqNo) }">
                    <td>{{ row.item.seqNo }}</td>
                    <td>{{ row.item.polNo }}</td>
                    <td>{{ row.item.renCnt }}</td>
                    <td>{{ row.item.clmNo }}</td>
                    <td>{{ row.item.logType }}</td>
                    <td>{{ row.item.createdBy }}</td>
                    <td class="table-action-header">
                    <table-action :rowData="row" query @query="doQuery(row.item)"></table-action></td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
            <v-card class="mt-2">
              <v-toolbar dense flat>
                <v-icon>mdi-format-align-justify</v-icon>
                <v-toolbar-title class="toolbar-title-2">Customer Log Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="doNew()" :loading="loading" v-if="!disabledAdd">
                  Add Log<v-icon right>mdi-plus</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs4 v-if="newMode">
                      <v-autocomplete :items="logTypeList" v-model="form.logType" :label="labels.logType" item-text="label" item-value="value" data-vv-name="logType" :data-vv-as="labels.logType" :error-messages="errors.collect('logType')" v-validate="'required'"></v-autocomplete>
                    </v-flex>
                    <v-flex xs4 v-else>
                      <v-subheader class="queryLabel">{{labels.logType}}</v-subheader>
                      <div class="queryValue" v-for="item in filterLogTypeList" :key="item.value">{{ item.value }}</div>
                    </v-flex>
                    <v-flex xs8></v-flex>
                    <v-flex lg12 md12 xs12 v-if="newMode">
                      <v-textarea data-vv-scope="custSvrLog" :label="labels.custSvrLog" v-model="form.custSvrLog" :error-messages="errors.collect('custSvrLog')" v-validate="'max:1000|entry'" data-vv-name="custSvrLog" :data-vv-as="labels.custSvrLog" :counter="1000" :rows="4"></v-textarea>
                    </v-flex>
                    <v-flex lg12 md12 xs12 v-else>
                      <v-subheader class="queryLabel">{{labels.custSvrLog}}</v-subheader>
                      <v-textarea data-vv-scope="custSvrLog" no-resize = true v-model="form.custSvrLog" :error-messages="errors.collect('custSvrLog')" data-vv-name="custSvrLog" :data-vv-as="labels.custSvrLog" :rows="10" readonly></v-textarea>
                    </v-flex>
                    <v-flex lg12 md12 xs12>
                      <v-textarea data-vv-scope="notes" :label="labels.notes" v-model="form.notes" :error-messages="errors.collect('notes')" v-validate="'max:1000|entry'" data-vv-name="notes" :data-vv-as="labels.notes" :counter="1000" :rows="4" :disabled="queryMode"></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
                      <div class="queryValue">{{createdBy}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                      <div class="queryValue">{{formatDisplayDate(createdDate)}}</div>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="!newMode">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
                      <div class="queryValue">{{modifiedBy}}</div>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                      <div class="queryValue">{{formatDisplayDate(modifiedDate)}}</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="!queryMode" color="primary" dark class="mb-2" @click="doSave" :loading="submitting">
                  Save
                <v-icon right>mdi-content-save</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="doPrint" :loading="loading" v-if="queryMode">
                  Print Log
                  <v-icon right>mdi-printer</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <v-dialog v-model="showFormDialog" width="800px"  persistent>
        <v-card>
          <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-pencil</v-icon>
            <v-toolbar-title>Query Customer Log </v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="newMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-plus</v-icon>
            <v-toolbar-title>Create Customer Log</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
               <v-layout row wrap>
                <v-flex xs4>
                  <v-autocomplete :items="logTypeList" v-model="form.logType" :label="labels.logType" item-text="label" item-value="value" data-vv-name="logType" :data-vv-as="labels.logType" :error-messages="errors.collect('logType')" v-validate="'required'" :disabled="disabledKey"></v-autocomplete>
                </v-flex>
                <v-flex xs8></v-flex>
                <v-flex lg12 md12 xs12>
                  <v-textarea data-vv-scope="custSvrLog" :label="labels.custSvrLog" v-model="form.custSvrLog" :error-messages="errors.collect('custSvrLog')" v-validate="'max:1000|entry'" data-vv-name="custSvrLog" :data-vv-as="labels.custSvrLog" :counter="1000" :rows="4" :disabled="disabledKey"></v-textarea>
                </v-flex>
                <v-flex lg12 md12 xs12>
                  <v-textarea data-vv-scope="notes" :label="labels.notes" v-model="form.notes" :error-messages="errors.collect('notes')" v-validate="'max:1000|entry'" data-vv-name="notes" :data-vv-as="labels.notes" :counter="1000" :rows="4" :disabled="disabledKey"></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn v-show="reviewMode" color="primary" dark class="mb-2" @click="doPrint">
                  Print Log
                  <v-icon right>mdi-printer</v-icon>
                </v-btn>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
                  <div class="queryValue">{{createdBy}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                  <div class="queryValue">{{formatDisplayDate(createdDate)}}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="!newMode">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
                  <div class="queryValue">{{modifiedBy}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                  <div class="queryValue">{{formatDisplayDate(modifiedDate)}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doCloseForm">Cancel</v-btn>
            <v-btn v-show="newMode" color="primary" flat @click.native="doCreate">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <v-dialog v-model="showCustLogHelpList" width="1000px"  persistent>
        <CustLogHelpList @close="doClose" @selectCustLogType="doAssignCustLogTypeHelpList($event)"></CustLogHelpList>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        <p>{{labels.promptRemove}}</p>
        <div class="queryValue">polNo: {{selected.polNo}}<br/>
        renCnt: {{selected.renCnt}}<br/>clmNo: {{selected.clmNo}}<br/>
        seqNo: {{selected.seqNo}}<br/>logType: {{selected.logType}}</div>
      </confirm>
    </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonMixins } from '@/mixins/common/commonMixin'
import { formatDisplayDate, formatDisplayTime } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import { custLogTypeView } from '@/const/underwriting'
import MessageMixin from '@/mixins/message'
import CustLogHelpList from '../helplist/CustLogHelpList'
import clone from 'clone'
export default {
  data() {
    return {
      labels: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        clmNo: 'Claim No.',
        logType: 'Type of Log',
        viewType: 'Filter By',
        custSvrLog: 'Description',
        notes: 'Notes',
        promptRemove: 'Are you sure that you want to delete the selected customer log?',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        polNo: null,
        renCnt: null,
        clmNo: '',
        seqNo: null,
        logType: '',
        custSvrLog: '',
        notes: ''
      },
      headers: [
        { text: 'Seq No.', value: 'seqNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Renewal Count', value: 'renCnt' },
        { text: 'Claim No.', value: 'clmNo' },
        { text: 'Log Type', value: 'logType' },
        { text: 'Entered User', value: 'createdBy' },
        TableConst.tableActionHeader
      ],
      selected: {
        polNo: '',
        renCnt: '',
        clmNo: '',
        seqNo: '',
        logType: ''
      },
      dto: {
        polNo: null,
        renCnt: null,
        endtCnt: null,
        seqNo: null,
        clmNo: null,
        logType: null,
        format: null
      },
      filters: {
        polNo: null,
        renCnt: null,
        clmNo: '',
        logType: undefined,
        createdDate: undefined,
        viewType: undefined
      },
      showFormDialog: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      submitting: false,
      loading: false,
      showCustLogHelpList: false,
      promptRemove: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      viewList: [],
      logTypeList: [],
      viewType: 'ALL',
      totalItems: 0,
      endtCnt: null,
      disabledKey: false,
      disabledAdd: true,
      selectedCustLogRecord: '',
      selectedCustLogRow: {},
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function(value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      // this.doFilters()
      if (this.manageType === 'claims') {
        await Promise.all([this.$store.dispatch('underwritingInit')])
      }
      await Promise.all([this.$store.dispatch('custLogInit')])
      if (this.customerLog.init === 1) {
        if (this.manageType === 'policy') {
          this.form.polNo = this.polMaster.polNo
          this.form.renCnt = this.polMaster.renCnt
          this.endtCnt = this.polMaster.endtCnt
        } else {
          this.form.polNo = this.commonInfo.polNo
          this.form.renCnt = this.commonInfo.renCnt
          this.endtCnt = this.commonInfo.endtCnt
          this.form.clmNo = this.commonInfo.clmNo
        }
        this.fetchData(true).then(() => {
          if (this.items.length > 0) {
            this.doEdit(this.items[0])
          }
        })
        this.getCustLogTypeList()
      }
    },
    async doEdit(data) {
      this.resetMessages()
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
      this.activeCustLog(data)
      await this.doReview(data)
    },
    async doQuery(data) {
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
      this.activeCustLog(data)
      await this.doReview(data)
    },
    doCreateNew() {
      this.newMode = true
      this.reviewMode = false
      this.showFormDialog = true
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayTime(xTime) {
      return formatDisplayTime(xTime)
    },
    async doPrint() {
      const apiURI = this.$store.state.underwriting.customerLogSettings.menu.printCustLog
      if (apiURI) {
        try {
          this.dto.polNo = this.selected.polNo
          this.dto.clmNo = this.selected.clmNo
          this.dto.renCnt = this.selected.renCnt
          this.dto.endtCnt = this.endtCnt
          this.dto.seqNo = this.selected.seqNo
          this.dto.logType = this.selected.logType
          this.dto.format = 'PDF'
          let custLogDto = clone(this.dto)
          await this.$http.post(apiURI, custLogDto)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async fetchData(options) {
      const apiURI = this.customerLog.menu.custLogList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          this.filters.polNo = this.form.polNo
          this.filters.renCnt = this.form.renCnt
          this.filters.clmNo = this.form.clmNo
          this.filters.viewType = this.viewType
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.displayDetails(result).then(() => {
            this.loading = false
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayDetails(result) {
      this.totalItems = result.data.totalElements
      const { data } = result.data
      this.items = []
      if (data) {
        for (let i in data) {
          const convertList = {
            polNo: data[i].polNo,
            renCnt: data[i].renCnt,
            clmNo: data[i].clmNo,
            logType: data[i].logType,
            seqNo: data[i].seqNo,
            custSvrLog: data[i].custSvrLog,
            notes: data[i].notes,
            createdBy: data[i].createdBy,
            createdDate: data[i].createdDate,
            createdTime: data[i].createdDate
          }
          this.items.push(convertList)
        }
      }
    },
    async doReview(item) {
      this.selected.polNo = item.polNo
      this.selected.renCnt = item.renCnt
      this.selected.clmNo = item.clmNo
      this.selected.seqNo = item.seqNo
      this.selected.logType = item.logType
      // this.disabledKey = true
      const apiURI = this.$store.state.underwriting.customerLogSettings.menu.revCustLog
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            polNo: item.polNo,
            renCnt: item.renCnt,
            clmNo: item.clmNo,
            seqNo: this.newMode ? 1 : item.seqNo,
            logType: item.logType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.logType = data.custLog.logType
            this.form.custSvrLog = data.custLog.custSvrLog
            this.form.notes = data.custLog.notes
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
            this.loading = false
            // this.showFormDialog = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.loading = false
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.newMode = false
      this.reviewMode = true
    },
    async getMaxSeqNo() {
      var success = false
      const apiURI = this.$store.state.underwriting.customerLogSettings.menu.custLogMaxSeqNo
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            polNo: this.form.polNo,
            renCnt: this.form.renCnt
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.seqNo = data.seqNo
          }
          success = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.newMode = false
      this.reviewMode = true
      return success
    },
    doNew() {
      this.resetMessages()
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.form.logType = ''
      this.form.custSvrLog = ''
      this.form.notes = ''
    },
    doSave() {
      if (this.newMode) {
        this.$validator.validateAll().then(success => {
          if (success) {
            this.doCreate().then(result => {
              if (result !== false) {
                // this.getMaxSeqNo().then(success => {
                //   if (success) {
                this.selectedCustLogRow = result
                this.doEdit(this.selectedCustLogRow)
                //   }
                // })
              }
            })
          } else {
            this.promptFieldCheck()
          }
        })
      } else if (this.reviewMode) {
        this.doUpdate()
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.underwriting.customerLogSettings.menu.createCustLog
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.fetchData()
            this.notify(data)
          }
          this.submitting = false
          return data
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.underwriting.customerLogSettings.menu.updCustLog
      if (apiURI) {
        this.submitting = true
        const expand = {
          polNo: this.selected.polNo,
          renCnt: this.selected.renCnt,
          clmNo: this.selected.clmNo,
          seqNo: this.selected.seqNo,
          logType: this.selected.logType,
          custSvrLog: this.form.custSvrLog,
          notes: this.form.notes
        }
        try {
          const result = await this.$http.put(apiURI, expand)
          const { data } = result
          if (data) {
            this.fetchData()
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(item) {
      this.selected.polNo = item.polNo
      this.selected.renCnt = item.renCnt
      this.selected.clmNo = item.clmNo
      this.selected.seqNo = item.seqNo
      this.selected.logType = item.logType
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.$store.state.underwriting.customerLogSettings.menu.delCustLog
      if (apiURI) {
        const expand = {
          polNo: this.selected.polNo,
          renCnt: this.selected.renCnt,
          clmNo: this.selected.clmNo,
          seqNo: this.selected.seqNo,
          logType: this.selected.logType
        }
        this.$http.post(apiURI, expand).then(result => {
          const { data } = result
          if (data) {
            this.doInit()
            // this.fetchData(true)
            this.notify(data)
          }
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    async getCustLogTypeList() {
      const apiUrl = this.$store.state.underwriting.customerLogSettings.menu.custLogTypeUWList
      if (apiUrl) {
        const expand = {
          manageType: this.manageType
        }
        this.$http.get(expandURI(apiUrl, expand)).then(result => {
          const { data } = result.data
          this.logTypeList = []
          if (data) {
            data[0].custLogType.map((datamap) => {
              const custLogTypeList = {
                value: datamap.logType,
                label: datamap.logType + ' - ' + datamap.logTypeDesc
              }
              this.logTypeList.push(custLogTypeList)
            })
          }
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    async doFilters() {
      if (this.viewType === 'ALL') {
        this.disabledAdd = true
        if (this.manageType === 'policy') {
          this.form.polNo = this.polMaster.polNo
          this.form.renCnt = this.polMaster.renCnt
          this.endtCnt = this.polMaster.endtCnt
        } else {
          this.form.polNo = this.commonInfo.polNo
          this.form.renCnt = this.commonInfo.renCnt
          this.endtCnt = this.commonInfo.endtCnt
          this.form.clmNo = this.commonInfo.clmNo
        }
        // this.fetchData(true)
        this.fetchData(true).then(() => {
          if (this.items.length > 0) {
            this.doEdit(this.items[0])
          }
        })
      } else if (this.viewType === 'UW') {
        if (this.manageType === 'policy') {
          this.disabledAdd = false
        } else {
          this.disabledAdd = true
        }
        this.viewTypeFiltered()
      } else {
        if (this.manageType === 'claims') {
          this.disabledAdd = false
        } else {
          this.disabledAdd = true
        }
        this.viewTypeFiltered()
      }
    },
    async viewTypeFiltered() {
      if (this.manageType === 'claims') {
        this.form.polNo = this.commonInfo.polNo
        this.form.renCnt = this.commonInfo.renCnt
        this.endtCnt = this.commonInfo.endtCnt
        this.form.clmNo = this.commonInfo.clmNo
      } else {
        this.form.polNo = this.polMaster.polNo
        this.form.renCnt = this.polMaster.renCnt
        this.endtCnt = this.polMaster.endtCnt
        this.form.clmNo = ''
      }
      // this.fetchData(true)
      this.fetchData(true).then(() => {
        if (this.items.length > 0) {
          this.doEdit(this.items[0])
        }
      })
    },
    doAssignCustLogTypeHelpList(custLogType) {
      this.form.logType = custLogType.logType
    },
    getHelpList() {
      this.resetMessages()
      this.showCustLogHelpList = true
    },
    doCloseForm() {
      this.showFormDialog = false
      this.form.logType = ''
      this.form.custSvrLog = ''
      this.form.notes = ''
      this.newMode = true
      this.reviewMode = false
      this.disabledKey = false
    },
    doClose() {
      this.showCustLogHelpList = false
      this.disabledKey = false
    },
    doCancel() {
      this.$router.push({ name: 'policyListing' })
    },
    activeCustLog(props) {
      this.selectedCustLogRecord = parseInt(props.seqNo)
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    filterLogTypeList() {
      return this.logTypeList.filter((list) => {
        return list.value === this.form.logType
      })
    },
    custLogTypeViewList() {
      let result = []
      Object.keys(custLogTypeView).forEach(function (key) {
        const viewType = custLogTypeView[key]
        result.push({
          value: key,
          label: viewType
        })
      })
      return result
    },
    customerLog() {
      return this.$store.state.underwriting.customerLogSettings
    }
  },
  mounted() {
    this.doInit()
  },
  props: {
    'manageType': String
  },
  components: {
    CustLogHelpList
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    commonMixins
  ]
}
</script>
<style lang="scss">
.activeCustLog {
  background-color: #FFF9C4FF
}
</style>
